import Vue from 'vue'
import Vuex from 'vuex'
import {state, getters, actions, mutations} from './pc_store'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin]
})
export default store



//////////////////
// WEBPACK FOOTER
// ./store/pc_index.js
// module id = null
// module chunks = 